<template>
  <div class="user-main">
    <div class="user-form">
      <div class="user-form-img">
        <img src="~assets/images/pic_01@2x.png" alt="" />
      </div>
      <div class="form-box">
        <img src="~assets/images/logo-title@2x.png" class="title-logo" />
        <h2>{{ $t("lang.loginPage1") }}</h2>
        <el-form
          ref="checkForm"
          :model="checkForm"
          autoComplete="off"
          :rules="checkFormRules"
          v-if="!codeSended"
        >
          <div class="form-group">
            <el-form-item prop="email">
              <el-input
                v-model="checkForm.email"
                type="text"
                :placeholder="$t('lang.loginPage8')"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </div>
          <el-button
            class="btn btn-login"
            :loading="btnLoading"
            @click="getVerificationCode"
            >{{$t('lang.loginPage12')}}</el-button
          >
        </el-form>
        <el-form
          ref="forgotForm"
          :model="forgotForm"
          autoComplete="off"
          :rules="forgotFormRules"
          v-else
        >
          <div class="form-group">
            <el-form-item prop="verifyCode">
              <el-input
                v-model="forgotForm.verifyCode"
                type="text"
                :placeholder="$t('lang.loginPage13')"
                auto-complete="off"
                @keyup.enter="handleLogin"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-group">
            <el-form-item prop="newPassword">
              <el-input
                :key="passwordType"
                ref="password"
                v-model="forgotForm.newPassword"
                :type="passwordType"
                :placeholder="$t('lang.loginPage9')"
                auto-complete="off"
              ></el-input>
              <span class="show-pwd" @click="showPwd">
                <i v-if="passwordType === 'password'" class="eye-close" />
                <i v-if="passwordType !== 'password'" class="eye-open" />
              </span>
            </el-form-item>
          </div>
          <div class="form-group">
            <el-form-item prop="checkPass">
              <el-input
                v-model="forgotForm.checkPass"
                :type="passwordType"
                :placeholder="$t('lang.loginPage14')"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </div>
          <el-button
            class="btn btn-login"
            :loading="btnLoading"
            @click="forgetPassword"
            >{{$t('lang.loginPage15')}}</el-button
          >
        </el-form>
        <p>
          {{$t('lang.loginPage16')}}
          <router-link to="/login" tag="a">{{$t('lang.loginPage7')}}</router-link> {{$t('lang.loginPage4')}}
        </p>
      </div>
    </div>
    <el-dialog
      title="滑动获取验证码"
      :show-close="false"
      :center="true"
      :width="'350px'"
      :top="'45vh'"
      :visible.sync="dialogSliderVisible"
    >
      <div class="code-slider">
        <nocaptcha
          :appkey="'FFFF0N0000000000662A'"
          :scene="'nc_login_h5'"
          :lang="'cn'"
          @callback="slideToGetCode"
        />
      </div>
    </el-dialog>
    <div class="app-bg"></div>
  </div>
</template>

<script>
import { ERR_OK } from "api/config";
import { getResetPasswordEmail, forgetPassword, slideToGetSmsCode } from "api/login";
import { validateMobile } from '@/utils/validate.js'
import { nocaptcha } from 'vue-nocaptcha';
let vm = null;
export default {
  components: {
    nocaptcha
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t('lang.loginPage18')));
      } else {
        if (this.forgotForm.newPassword !== "") {
          this.$refs.forgotForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t('lang.loginPage19')));
      } else if (value !== this.forgotForm.newPassword) {
        callback(new Error(vm.$t('lang.loginPage20')));
      } else {
        callback();
      }
    };
    return {
      language: localStorage.getItem("language"),
      btnLoading: false,
      codeSended: false,
      dialogSliderVisible: false,
      passwordType: 'password',
      checkForm: {
        email: ""
      },
      checkFormRules: {
        email: [
          {
            required: true,
            message: this.$t('lang.loginPage10'),
            trigger: "blur"
          }
        ]
      },
      forgotForm: {
        verifyCode: "",
        newPassword: "",
        checkPass: ""
      },
      forgotFormRules: {
        verifyCode: [
          {
            required: true,
            message: this.$t('lang.loginPage17'),
            trigger: "blur"
          }
        ],
        newPassword: [
          { validator: validatePass, trigger: "blur" },
          {
            min: 6,
            max: 14,
            message: this.$t('lang.loginPage11'),
            trigger: "blur"
          }
        ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  created() {
    vm = this;
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    getVerificationCode() {
      this.$refs.checkForm.validate(valid => {
        if (valid) {
          if (validateMobile(this.checkForm.email)) {
            this.btnLoading = true;
            this.dialogSliderVisible = true
          } else {
            this.btnLoading = true;
            getResetPasswordEmail(this.checkForm)
              .then(response => {
                if (response.status !== 200) {
                  this.$message.error(response.data.message);
                } else {
                  if (response.data.code === ERR_OK) {
                    this.$message.success(vm.$t('lang.loginPage21'));
                    this.codeSended = true;
                  } else {
                    this.$message.error(response.data.message);
                  }
                }
                this.btnLoading = false;
              })
              .catch(() => {
                this.btnLoading = false;
              });
          }
        }
      });
    },
    slideToGetCode(data) {
      const mobile = this.checkForm.email
      if (mobile === '') {
        this.$message.error('请输入手机号')
        data.nc.reset()
        return false
      } else if (!(/^\d+$/.test(mobile))) {
        this.$message.error('请输入手机号')
        data.nc.reset()
        return false
      }
      slideToGetSmsCode({
        smsCodeType: 'FORGET_PW',
        sessionId: data.csessionid,
        token: data.token,
        scene: data.scene,
        sig: data.sig,
        mobile: '+86' + mobile
      }).then(response => {
        if (response.status !== 200) {
          data.nc.reset()
          this.list = []
          this.$message.error(response.data.message)
        } else {
          if (+response.data.code === 200) {
            this.$message.success('验证码已发送至您的手机');
            this.codeSended = true;
            this.dialogSliderVisible = false
            this.btnLoading = false;
            data.nc.reset()
          } else {
            data.nc.reset()
            this.$message.error(response.data.message)
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    forgetPassword() {
      let vm = this;
      this.$refs.forgotForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          var data = Object.assign(
            { email: this.checkForm.email },
            this.forgotForm
          );
          forgetPassword(data)
            .then(response => {
              if (response.status !== 200) {
                this.$message.error(response.data.message);
              } else {
                if (response.data.code === ERR_OK) {
                  this.$message.success(vm.$t('lang.loginPage22'));
                  setTimeout(function() {
                    vm.$router.push({
                      path: "login"
                    });
                  }, 2000);
                } else {
                  this.$message.error(response.data.message);
                }
              }
              this.btnLoading = false;
            })
            .catch(() => {
              this.btnLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.user-form {
  width: 998px;
  height: 598px;
  position: absolute;
  border: 1px solid #dedede;
  top: 50%;
  left: 50%;
  margin: -300px 0px 0px -500px;
  background-color: $white;
  border-radius: 6px;
}
.user-form-img {
  width: 348px;
  height: 225px;
  float: left;
  margin: 187px 76px;
  img {
    display: block;
    width: 100%;
    line-height: 0;
    border: 0;
  }
}
.form-box {
  width: 400px;
  height: 500px;
  margin: 40px;
  float: right;
  position: relative;
  .title-logo {
    display: block;
    width: 155px;
    height: 58px;
    margin: 40px auto 20px;
  }
  h2 {
    color: $baseColor;
    font-size: 30px;
    text-align: center;
    margin-bottom: 50px;
  }
  .form-group {
    width: 285px;
    height: 36px;
    background: #f5f5f5;
    border-radius: 20px;
    input {
      width: 100%;
      height: 36px;
      line-height: 36px;
      text-indent: 20px;
      background: transparent;
      border: 0;
      outline: none;
    }
  }
  .btn {
    width: 285px;
    margin: 0 auto 50px;
  }
  p {
    text-align: center;
    font-size: 18px;
    color: #1b1b1b;
    a {
      color: $baseColor;
      text-decoration: none;
    }
  }
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 0px;
  width: 16px;
  height: 40px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;

  .eye-close {
    display: block;
    width: 16px;
    height: 40px;
    background: url(~assets/images/eye-close.png) center center no-repeat;
    background-size: contain;
  }

  .eye-open {
    display: block;
    width: 16px;
    height: 40px;
    background: url(~assets/images/eye-open.png) center center no-repeat;
    background-size: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/register/forgot.vue